export default __webpack_public_path__ + "static/media/intro-banner.ff4ff912.png";